import { useEffect, useState } from "react";
import { Toast } from "../components";
import { aiConfigService } from "../services/api/aiConfigService";
import { fetchBinaryFile } from "../utils/helper";

/**
 * Custom hook to manage camera controls (sound, binary data)
 * @param {Object} item - Camera item
 * @param {Function} restartCamera - Callback to restart camera
 * @returns {Object} - Camera controls state and functions
 */
export const useCameraControls = (item, restartCamera) => {
    const [isSound, setIsSound] = useState(item?.is_VOICE);
    const [binaryData, setBinaryData] = useState(null);

    // Sync sound state with item prop
    useEffect(() => {
        setIsSound(item?.is_VOICE);
    }, [item?.is_VOICE]);

    // Fetch camera snapshot image
    useEffect(() => {
        fetchBinaryFile(`${item.image}`)
            .then((data) => setBinaryData(data))
            .catch((error) => console.error("Error fetching binary file:", error));
    }, [item.image]);

    // Toggle sound on/off
    const handleToggleSound = async (code) => {
        try {
            const body = {
                is_voice: isSound ? "0" : "1",
            };
            await aiConfigService.putChangeIsVoice(code, body);
            restartCamera(code, false);
            setIsSound(!isSound);
        } catch (error) {
            Toast.open("Không thành công", "danger");
        }
    };

    return {
        isSound,
        binaryData,
        handleToggleSound,
    };
};

